























































































































import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "AlertFeedGuide",
})
export default class AlertFeedGuide extends Vue {}
